import { DEVICE_ID_KEY } from '@/constants/localStorageKeys'
import { v4 } from 'uuid'

export function getDeviceId() {
  let deviceId = localStorage.getItem(DEVICE_ID_KEY)

  if (!deviceId) {
    deviceId = v4()
    localStorage.setItem(DEVICE_ID_KEY, deviceId)
  }
  return deviceId
}
